import t from '@jetshop/intl';
import { styled } from 'linaria/react';
import React from 'react';
import { useLocation } from 'react-router';
import { theme } from '../Theme';

const Wrapper = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  ${theme.below.md} {
    flex-wrap: wrap;
    a {
      margin-bottom: 10px;
    }
  }
`;
const PaginationButton = styled('a')`
  background: white;
  color: #333333;
  text-transform: uppercase;
  padding: 8px;
  text-align: center;
  min-width: 35px;
  border: 1px solid #eaeaea;
  text-decoration: none;
  margin: 0 5px;
  font-size: 12px;
  font-weight: 700;
  transition: all, 0.2s ease;

  &.active {
    background: ${theme.colors.accent};
    color: white;
  }

  &.large {
    padding: 8px 30px;
    font-weight: 700;
    &.disabled {
      cursor: not-allowed;
      &:hover {
        background: white;
        color: #333333;
      }
    }
  }

  &:hover {
    background: ${theme.colors.accent};
    color: white;
  }
`;

export function Pagination(props) {
  const location = useLocation();
  const items = [];
  for (let i = 0; i < props.totalPages; i++) {
    items.push(i + 1);
  }
  if (props.totalPages === 1) {
    return null;
  }

  return (
    <Wrapper>
      {/* <UIPagination {...props} className={paginationStyles} /> */}

      {props.currentPage > 2 && (
        <>
          <PaginationButton
            className={'not-active'}
            href={location.pathname + '?page=1'}
            onClick={e => {
              e.preventDefault();
              props.goToPage(1);
            }}
          >
            1
          </PaginationButton>
          {props.currentPage > 3 && '...'}
        </>
      )}
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {items.length < 4 ? (
            <PaginationButton
              className={props.currentPage === item ? 'active' : 'not-active'}
              href={location.pathname + '?page=' + item}
              onClick={e => {
                e.preventDefault();
                props.goToPage(item);
              }}
            >
              {item}
            </PaginationButton>
          ) : (
            <>
              {props.currentPage === index + 1 ||
              props.currentPage - 1 === index + 1 ||
              props.currentPage + 1 === index + 1 ||
              item === items.length ? (
                <>
                  {item === items.length && '...'}
                  <PaginationButton
                    className={
                      props.currentPage === item ? 'active' : 'not-active'
                    }
                    href={location.pathname + '?page=' + item}
                    onClick={e => {
                      e.preventDefault();
                      props.goToPage(item);
                    }}
                  >
                    {item}
                  </PaginationButton>
                </>
              ) : null}
            </>
          )}
        </React.Fragment>
      ))}
      <PaginationButton
        className={
          props.currentPage === props.totalPages ? 'disabled large' : 'large'
        }
        href={
          location.pathname +
          '?page=' +
          (props.currentPage !== props.totalPages
            ? props.currentPage + 1
            : props.currentPage)
        }
        onClick={e => {
          e.preventDefault();
          props.nextPage();
        }}
      >
        {t('Next page')}
      </PaginationButton>
    </Wrapper>
  );
}
